import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { AppointmentInfo, Layout, Modal } from "components";
import { useSelector, useDispatch } from "react-redux";
import {
  cancelAppointmentBooking,
  appointmentTakenUp
} from "services/api-service";

import {
  addBusinessDays,
  YEAR_MONTH_DAY_2,
  YEAR_MONTH_DAY_HOUR_MINUTE_SECOND,
  YEAR_MONTH_DAY,
  YEAR_MONTH_DAY_HOUR_MINUTE,
  FULL_DATE_TIME_FORMAT
} from "constants/date";
import { changeSelectedDate } from "redux/appointmentBooking";

import moment from "moment";

import {
  DEFAULT_ROUTE,
  CANCELLATION,
  BOOKED,
  APPOINTMENT_BOOKING
} from "constants/route";

import { YOUR_BOOKING_IS_CONFIRMED } from "constants/text";

import { CommonButton, HomeButton } from "components/CommonUI";

const ZERO = 0;
const TODAY = moment().format(YEAR_MONTH_DAY);
const ERROR_STATUS_CODE = 500;

export default function CallApptBookingAcknowledgement() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalBodyText, setModalBodyText] = useState({
    value: "",
    label: "",
    header: ""
  });

  const { nric, mobile } = useSelector((state) => state.appointment);

  const {
    selectedTimeSlot,
    selectedApptType,
    registeredAppointmentId,
    displaySelectedDate,
    displaySelectedTime,
    attendingWithAnother,
    anotherNric,
    bookingTxnId,
    transTime
  } = useSelector((state) => state.appointmentBooking);

  const { mainWebDisplayText } = useSelector((state) => state.services);

  // useEffect(() => {
  //   window.onpopstate = () => {
  //     navigate(pathname);
  //   };
  // });

  const appointmentInfo = {
    idType: "NRIC/FIN/AccountNo",
    idNo: `${nric}`,
    scheme: `${mainWebDisplayText}`,
    mode: `${selectedApptType.label}`,
    date: `${displaySelectedDate}`,
    time: `${displaySelectedTime}`,
    bookingTxnId: `${bookingTxnId}`
  };

  const contactNo = `${mobile}`;

  const onCancelBooking = async () => {
    const appointmentDate = moment(
      `${displaySelectedDate} ${displaySelectedTime}`,
      YEAR_MONTH_DAY_HOUR_MINUTE
    ).format(YEAR_MONTH_DAY_HOUR_MINUTE_SECOND);

    const response = await cancelAppointmentBooking(
      Number(registeredAppointmentId),
      nric,
      selectedTimeSlot.value,
      attendingWithAnother,
      mobile,
      appointmentDate,
      ""
    );
    if (response.status === 200 && Boolean(response.data.status)) {
      navigate(CANCELLATION, {
        replace: true,
        state: { transTime: response.data.transTime }
      });
      return;
    }

    if (
      response.data.message == "CANCELLATION_FAILED" ||
      response.data.message == "INVALID_BOOKING_STATUS"
    ) {
      setModalBodyText({
        value: response.status,
        label: "The booking may have been cancelled by another session.",
        header: "Cancellation failed"
      });
    }
  };

  const onChangeBooking = async () => {
    const response = await appointmentTakenUp(
      selectedApptType.value,
      moment().format(YEAR_MONTH_DAY_2)
    );

    if (response.data.data.length === ZERO) {
      navigate(BOOKED);
      return;
    }
    dispatch(changeSelectedDate(addBusinessDays(new Date(), 1)));
    navigate(APPOINTMENT_BOOKING);
  };

  const onHideModal = () => setIsOpenModal(false);

  const onConfirm = (id, text) => {
    setModalBodyText({ value: id, label: text, header: "Confirmation" });
    setIsOpenModal(true);
  };

  const goToHome = () =>
    (window.location.href = `${process.env.PUBLIC_URL}${DEFAULT_ROUTE}`);

  const footer =
    modalBodyText.value === ERROR_STATUS_CODE ? (
      <div className="d-flex flex-sm-row flex-column-reverse justify-content-around w-100">
        <CommonButton
          text={"OK"}
          leftOrRight={"right"}
          onClick={goToHome}
          className="mb-sm-0 mb-3"
        />
        {/* <Button
          className="btn cmp-button pbs-style--primary rounded-pill me-3"
          onClick={alreadyTaken ? goHome : handleOK}
        >
          OK
        </Button> */}
      </div>
    ) : (
      <div
        className="d-flex flex-sm-row flex-column-reverse justify-content-around w-100"
        // style={{ display: "flex", justifyContent: "space-around", width: "100%" }}
      >
        <CommonButton
          text={"Back"}
          onClick={onHideModal}
          leftOrRight={"left"}
        />

        {/* <Button
          className="btn left-button cmp-button pbs-style--primary rounded-pill me-3"
          onClick={onHideModal}
        >
          No
        </Button> */}

        <CommonButton
          text={"Cancel Appointment"}
          onClick={
            modalBodyText.value === 1
              ? onChangeBooking
              : modalBodyText.value === 2
              ? goToHome
              : onCancelBooking
          }
          leftOrRight={"right"}
          className="mb-sm-0 mb-3"
        />

        {/* <Button
          className="btn cmp-button pbs-style--primary rounded-pill"
          onClick={
            modalBodyText.value === 1
              ? onChangeBooking
              : modalBodyText.value === 2
              ? goToHome
              : onCancelBooking
          }
        >
          Yes
        </Button> */}
      </div>
    );

  const body = (
    <div className="center">
      <h3>{modalBodyText.header}</h3>
      <br />
      <p>{modalBodyText.label}</p>
      {/* <p className="dark-green">Are you sure ?</p> */}
    </div>
  );

  return (
    <Layout subHeader={"How can we help?"}>
      <div className="form-box my-5">
        <div className="my-3">
          <div className="center">
            <div className="row text-secondary">
              <i class="icon-dls-tick-solid icon-big"></i>
              <h3 className="col-md-8 offset-md-2 title__text">
                {YOUR_BOOKING_IS_CONFIRMED}
              </h3>
              <h4>We will send you a confirmation message shortly.</h4>
            </div>
          </div>
          <AppointmentInfo
            appointmentInfo={appointmentInfo}
            contactNo={contactNo}
          />
          <div className="col-md-8 offset-md-2 col-10 offset-1 text-secondary mt-4">
            <div class="instructions instructions-mod">
              <div class="instructions-content">
                <h5>Important Notes</h5>

                {selectedApptType.code === "CA" && (
                  <>
                    <div>
                      You will receive a SMS to the mobile number provided at
                      your appointment time to initiate the call appointment.
                      Click{" "}
                      <a
                        className="cmp-button cmp-button--link"
                        href={`${window.callAppointmentDemoUrl}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="cmp-button__text">
                          Call Appointment Demo
                        </span>
                      </a>{" "}
                      to find out more about the call appointment.
                    </div>
                    <br />

                    <div>
                      To help us assist you better, you will be put through
                      Singpass 2FA authentication. If you are making the
                      appointment on behalf, please ensure that the CPF member
                      is present in the event clarification is required.
                    </div>
                    {displaySelectedDate != TODAY && (
                      <>
                        <br />
                        <div>
                          If you are changing the mode of appointment, please
                          cancel the appointment and make a new appointment in
                          your preferred service channel. Otherwise, you can
                          reschedule the appointment for changes to date or
                          time.
                          <br />
                          <br />
                          Please reschedule or cancel your appointment at least
                          1 calendar day in advance.
                        </div>
                      </>
                    )}
                  </>
                )}

                {selectedApptType.code === "VD" && (
                  <>
                    <div>
                      You will receive a SMS link to the mobile number provided
                      At your appointment time to initiate the video
                      appointment. Click here "Video Appointment Demo" to find
                      out more about The video Appointment.
                    </div>
                    {displaySelectedDate != TODAY && (
                      <>
                        <br />
                        <div>
                          If you are changing the mode of appointment, please
                          cancel the appointment and make a new appointment in
                          your preferred service channel. Otherwise, you can
                          reschedule the appointment for changes to service
                          centre, date or time.
                          <br />
                          <br />
                          Please reschedule or cancel your appointment at least
                          1 calendar day in advance.
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>

            {displaySelectedDate != TODAY && (
              <div>
                <div style={{ margin: 12 }}>
                  <a
                    className="cmp-button cmp-button--link"
                    // href={}
                    rel="noreferrer"
                    onClick={onChangeBooking}
                  >
                    <span
                      className="cmp-button__text fs-5"
                      style={{ textAlign: "center" }}
                    >
                      Reschedule Appointment
                    </span>
                  </a>
                </div>
                <div style={{ margin: 12 }}>
                  <a
                    className="cmp-button cmp-button--link"
                    // href={}
                    rel="noreferrer"
                    onClick={() =>
                      onConfirm(
                        0,
                        "Are you sure you want to cancel this appointment?"
                      )
                    }
                  >
                    <span
                      className="cmp-button__text fs-5"
                      style={{ textAlign: "center" }}
                    >
                      Cancel Appointment
                    </span>
                  </a>
                </div>
              </div>
            )}
            <div
              style={{
                marginLeft: 20,
                paddingTop: 10
              }}
              className="trans-date"
            >
              {/* Transaction Date : 06 Jul 2022 11:17 AM */}
              Transaction Date :{" "}
              {moment(transTime).format(FULL_DATE_TIME_FORMAT)}
            </div>
          </div>
          <div className="form-footer flex-sm-row flex-column justify-content-between">
            <HomeButton
              // onClick={() => onConfirm(2, "Your data will be clear.")}
              onClick={goToHome}
            />
          </div>
        </div>
        <Modal
          isOpen={isOpenModal}
          onHide={onHideModal}
          body={body}
          footer={footer}
        />
      </div>
    </Layout>
  );
}
